import modalClose from './modal_close.png';
import collapseDarkSmall from './collapse-dark-small.png';
import expandDarkSmall from './expand-dark-small.png';
import archive from './archive.png';
import modalError from './modal-error.png';
import drafts from './drafts.png';
import home from './home.png';
import chevronDown from './chevron-down.png';
import chevronUp from './chevron-up.png';
import folder from './folder.png';
import search from './reg-search.png';
import searchLink from './search.png';
import tabletShow from './tablet-show.png';
import tabletHide from './tablet-hide.png';
import mailBoxActions from './mailbox-actions.png';
import burgerMenu from './menu-bg-all.png';
import sprite from './sprite.png';
import registerAll from './register_all_large.png';
import alert from './alert.png';
import checkmark from './checkmark.png';
import file from './file.png';
import calendar from './calendar.png';
import clock from './clock.png';
import close from './close.png';
import downArrow from './arrowDown.png';
import upArrow from './downArrow.png';
import selectedFlag from './flagSelected.svg';
import hoveredFlag from './flagHovered.svg';
import flagFolder from './flag-linear-gray.svg';
import stamp from './stamp.png';
import arrowForward from './arrowForward.svg';
import arrowBackward from './arrowBackward.svg';
import CheckmarkNew from './Checkmark_ngdp.png';
import closeNew from './Close_ngdp.png';

const images = {
    alert,
    archive,
    burgerMenu,
    calendar,
    checkmark,
    CheckmarkNew,
    closeNew,
    chevronDown,
    chevronUp,
    clock,
    close,
    collapseDarkSmall,
    drafts,
    expandDarkSmall,
    file,
    folder,
    home,
    mailBoxActions,
    modalClose,
    modalError,
    registerAll,
    search,
    searchLink,
    sprite,
    tabletHide,
    tabletShow,
    downArrow,
    upArrow,
    selectedFlag,
    hoveredFlag,
    flagFolder,
    stamp,
    arrowForward,
    arrowBackward,
};

export default images;
